import { apiConstants } from "../../utils/apiConstants";
import { apiTypes } from "../../utils/apiTypes";
import apiRequestType from "../apiRequestType";

const getClassDetailsById = (shotClassId, status) => {
  return apiRequestType(
    apiTypes.GET,
    apiConstants.MANAGE.GET_CLASSDETAILS_BY_ID(shotClassId, status)
  );
};

export default getClassDetailsById;
